<!-- What this student has been told to watch -->
<div class="student-card p-3 p-md-4 mb-3">

  <div class="d-flex align-items-center mb-3">
    <i class="bi bi-arrow-repeat color-brand-primary me-2"></i>
    <div>
      <p class="fs-20 fw-800 color-gray-950 mb-0">{{'students.videos.assigned_title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">
        {{'students.videos.assigned_desc'|translate: {name: studentName} }}
      </p>
    </div>
  </div>

  <ngx-skeleton-loader
    *ngIf="assignedIsLoading && !assignedTasks.length" count="2" appearance="line"
    [theme]="{height: '56px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

  <p class="fs-small fw-400 color-gray-400 mb-0"
     *ngIf="!assignedIsLoading && !assignedTasks.length">
    {{'students.videos.no_assignment'|translate}}
  </p>

  <div class="assigned-row d-flex align-items-center p-3 mb-2" *ngFor="let task of assignedTasks"
       [class.completed]="task.isCompleted">
    <i class="bi me-3 assigned-check"
       [class.bi-check-circle-fill]="task.isCompleted" [class.bi-circle]="!task.isCompleted"
       [ngbTooltip]="(task.isCompleted ? 'students.videos.watched' : 'students.videos.not_watched')|translate"
       container="body"></i>

    <div class="flex-grow-1 overflow-hidden">
      <p class="fs-small fw-800 color-gray-950 mb-1 text-truncate">{{taskContentTitle(task)}}</p>
      <div class="d-flex align-items-center gap-2">
        <app-content-type-badge [type]="taskContentType(task)"></app-content-type-badge>
        <span class="fs-xsmall fw-400 color-gray-400" *ngIf="taskDuration(task)">
          <i class="bi bi-clock me-1"></i>{{taskDuration(task)|timeFormat}}
        </span>
      </div>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="confirmRemove(task)"
       [ngbTooltip]="'students.videos.remove'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

</div>

<!-- The student's own library -->
<div class="student-card p-3 p-md-4">

  <div class="d-flex align-items-center mb-3">
    <i class="bi bi-play-btn color-brand-primary me-2"></i>
    <div>
      <p class="fs-20 fw-800 color-gray-950 mb-0">{{'students.videos.library_title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">{{'students.videos.library_desc'|translate}}</p>
    </div>
  </div>

  <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
    <div class="filter-switch d-inline-flex">
      <a class="filter-option text-center fs-small fw-800 clickable px-3 py-1"
         [class.active]="filter === 'all'" (click)="setFilter('all')">
        {{'students.videos.filter_all'|translate}}
      </a>
      <a class="filter-option text-center fs-small fw-800 clickable px-3 py-1"
         [class.active]="filter === 'video'" (click)="setFilter('video')">
        {{'students.videos.filter_video'|translate}}
      </a>
      <a class="filter-option text-center fs-small fw-800 clickable px-3 py-1"
         [class.active]="filter === 'live-stream'" (click)="setFilter('live-stream')">
        {{'students.videos.filter_live'|translate}}
      </a>
    </div>

    <div class="search-box mt-2 mt-md-0">
      <app-gray-text-input
        customClass="compact-input"
        [placeholder]="'students.videos.search'|translate"
        [formControl]="searchControl"></app-gray-text-input>
    </div>
  </div>

  <div class="row g-3" *ngIf="isLoading && !items.length">
    <div class="col-12 col-xl-6" *ngFor="let placeholder of [1, 2, 3, 4]">
      <ngx-skeleton-loader
        count="1" appearance="line"
        [theme]="{height: '260px', 'border-radius': '16px', margin: '0'}"/>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-12 col-xl-6" *ngFor="let item of items">
      <coach-content-card
        [item]="item" [isAssigned]="isAssigned(item)" [studentName]="studentName"
        (previewRequested)="preview($event)"
        (assignRequested)="assign($event)"></coach-content-card>
    </div>
  </div>

  <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!isLoading && !items.length">
    {{'students.videos.empty'|translate}}
  </p>

  <div class="text-center mt-3" *ngIf="hasMore">
    <app-gray-button
      color="stroke-gray" [fullWidth]="false" padding="px-3 py-2" [weight]="800"
      customClass="fs-small border-8"
      [isLoading]="isLoading" [disabled]="isLoading"
      [text]="'students.videos.load_more'|translate"
      (click)="loadMore()"></app-gray-button>
  </div>

</div>
